<template>
	<div class="subscribe">
		<form style="margin-bottom:10px;">
			<a-row type="flex" justify="start" :gutter="10">
				<a-col :span="5">
					<a-input v-model="keyword" placeholder="UID / 姓名 / 手机号 / openid" />
				</a-col>
				<a-col :span="4">
					<a-select v-model="type" style="width:100%" placeholder="订阅类别">
						<a-select-option value="">全部类别</a-select-option>
						<a-select-option value="1">市场信息</a-select-option>
						<a-select-option value="2">锂电行情</a-select-option>
						<a-select-option value="3">锂电市场</a-select-option>
					</a-select>
				</a-col>
				<a-col :span="4">
					<a-select v-model="status" style="width:100%" placeholder="推送状态">
						<a-select-option value="">全部状态</a-select-option>
						<a-select-option value="0">待推送</a-select-option>
						<a-select-option value="1">已推送</a-select-option>
					</a-select>
				</a-col>
				<a-col :span="6">
					<a-range-picker @change="onChange" />
				</a-col>
				<a-col :span="2">
					<a-button type="primary" @click="get_data(1)">搜索</a-button>
				</a-col>
			</a-row>
		</form>
		<a-table :columns="columns" :data-source="tableData" @change="change_filter" :loading="loading"
			:pagination="page" bordered :rowKey="record => record.id">
			<template slot="status_slot" slot-scope="text, record">
				<a-tag :color="record.status == 1 ? 'green' : 'blue'">{{ record.status_str }}</a-tag>
			</template>
			<template slot="type_slot" slot-scope="text, record">
				<span>{{ record.type_str }}</span>
			</template>
		</a-table>
	</div>
</template>

<script>
	import Func from '../../common/func'
	const columns = [{
			title: '#',
			dataIndex: 'id',
			key: 'id',
			width: 70,
		},
		{
			title: 'UID',
			dataIndex: 'uid',
			key: 'uid',
			width: 80,
		},
		{
			title: '姓名',
			dataIndex: 'truename',
			key: 'truename',
			width: 120,
		},
		{
			title: '手机号',
			dataIndex: 'mobile',
			key: 'mobile',
			width: 130,
		},
		{
			title: '订阅类别',
			dataIndex: 'type_str',
			key: 'type_str',
			width: 110,
			scopedSlots: {
				customRender: 'type_slot'
			},
		},
		{
			title: '订阅对象',
			dataIndex: 'target_name',
			key: 'target_name',
			width: 180,
		},
		{
			title: '状态',
			dataIndex: 'status_str',
			key: 'status_str',
			width: 100,
			scopedSlots: {
				customRender: 'status_slot'
			},
		},
		{
			title: '订阅时间',
			dataIndex: 'created',
			key: 'created',
			width: 170,
		},
		{
			title: '推送时间',
			dataIndex: 'pushed_at',
			key: 'pushed_at',
			width: 170,
		},
		{
			title: 'openid',
			dataIndex: 'openid',
			key: 'openid',
			ellipsis: true
		}
	];
	export default {
		name: 'Subscribe',
		data() {
			return {
				columns,
				keyword: '',
				type: '',
				status: '',
				range: [],
				tableData: [],
				loading: false,
				page: {
					current: 1,
					total: 0,
					pageSize: 10
				}
			}
		},
		mounted() {
			this.get_data();
		},
		methods: {
			onChange(date, dateString) {
				this.range = dateString;
			},
			change_filter(pagination) {
				this.get_data(pagination.current);
			},
			get_data(page, tip) {
				if (!page) {
					page = this.page.current || 1;
				}
				if (!tip) {
					this.loading = true;
				}
				Func.url_get({
					action: 'subscribe.index',
					keyword: this.keyword,
					type: this.type,
					status: this.status,
					range: this.range,
					page: page
				}, (res) => {
					if (res.error === 0) {
						this.tableData = res.info.list || [];
						this.page = {
							pageSize: 10,
							total: res.info.foot ? res.info.foot.total : 0,
							current: res.info.foot ? parseInt(res.info.foot.current) : 1
						};
					}
					this.loading = false;
				});
			}
		}
	}
</script>
<style lang="scss">

</style>
